import { Plus } from "@untitledui/icons";
import { useState } from "react";
import { useCohortRules } from "@/api/cohort-rules";
import { SlideoutMenu } from "@/components/application/slideout-menus/slideout-menu";
import { Button } from "@/components/base/buttons/button";
import { DeleteRuleDialog } from "./delete-rule-dialog";
import { RuleListRow } from "./rule-list-row";

interface RulesListDrawerProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  onEdit: (ruleId: string) => void;
  onCreate: () => void;
  onCohortsChanged: () => void;
}

export function RulesListDrawer({ open, onOpenChange, onEdit, onCreate, onCohortsChanged }: RulesListDrawerProps) {
  const { data } = useCohortRules();
  const [deleteTarget, setDeleteTarget] = useState<{ ruleId: string; name: string } | undefined>(undefined);

  const rules = data?.items ?? [];

  return (
    <>
      <SlideoutMenu isOpen={open} onOpenChange={onOpenChange} isDismissable>
        <SlideoutMenu.Header onClose={() => onOpenChange(false)}>
          <h2 className="text-lg font-semibold text-primary">Cohort Rules</h2>
        </SlideoutMenu.Header>

        <SlideoutMenu.Content>
          <div className="flex flex-col divide-y divide-secondary">
            {rules.map((rule) => (
              <RuleListRow
                key={rule.ruleId}
                rule={rule}
                onEdit={() => onEdit(rule.ruleId)}
                onDelete={() => setDeleteTarget({ ruleId: rule.ruleId, name: rule.name })}
              />
            ))}
          </div>
        </SlideoutMenu.Content>

        <SlideoutMenu.Footer>
          <Button color="primary" iconLeading={Plus} onClick={onCreate}>
            New Rule
          </Button>
        </SlideoutMenu.Footer>
      </SlideoutMenu>

      <DeleteRuleDialog
        target={deleteTarget}
        onClose={() => setDeleteTarget(undefined)}
        onCohortsChanged={onCohortsChanged}
      />
    </>
  );
}
